<ion-header>
	<ion-toolbar>
		<ion-buttons slot="start">
			<ion-button color="medium" (click)="cancel()">
				<ion-icon name="arrow-back-outline" slot="start"></ion-icon>
			</ion-button>
		</ion-buttons>
		<ion-title>{{ 'MODAL.ADD-TRIP.TITLE' | translate }}</ion-title>
	</ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
	<ion-item>
		<ion-input labelPlacement="stacked" type="number"
			label="{{ 'MODAL.ADD-TRIP.LABEL' | translate }}"
			[(ngModel)]="tripId"
			placeholder="{{ 'MODAL.ADD-TRIP.PLACEHOLDER' | translate }}"></ion-input>
	</ion-item>
	<ion-button expand="block"
		(click)="confirm()">{{ 'MODAL.ADD-TRIP.CONFIRM' | translate }}</ion-button>
</ion-content>
